/**
 * Vocabulário da sequência de instalação (AC12).
 *
 * Em módulo próprio, e não junto dos componentes: arquivo que exporta constante
 * ao lado de componente quebra o hot reload do React, que precisa de arquivos só
 * de componentes para trocar a árvore sem recarregar a página.
 */

/** Identidade de cada passo. `parameters` entra com o AB#85822. */
export type SkillInstallerStepId =
  | "overview"
  | "license"
  | "files"
  | "integrations"
  | "parameters"
  | "review";

export interface SkillInstallerStep {
  id: SkillInstallerStepId;
  label: string;
}

/** O arquivo de instruções não entra na árvore: ele é o passo de apresentação. */
export const SKILL_ENTRY_FILE = "SKILL.md";
